// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "h1[data-v-3c77bd86]{display:flex;flex-direction:column;align-items:flex-start}h1 .subheadline[data-v-3c77bd86]{font-size:1rem;margin-bottom:2rem}h1 .main-headline[data-v-3c77bd86]{font-weight:700;font-size:clamp(2.75rem,7vw,5rem)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
